import { render, staticRenderFns } from "./commonLeaveRecordsList.vue?vue&type=template&id=01c29654&scoped=true"
import script from "./commonLeaveRecordsList.vue?vue&type=script&lang=js"
export * from "./commonLeaveRecordsList.vue?vue&type=script&lang=js"
import style0 from "./commonLeaveRecordsList.vue?vue&type=style&index=0&id=01c29654&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c29654",
  null
  
)

export default component.exports